import React from 'react';
import { Stamp } from '../Stamp/Stamp.jsx';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

/**
 * Transient notice. Tone fills the whole toast; `stamp` pins a Stamp to its corner.
 *
 * @param {object} p
 * @param {React.ReactNode} [p.action]
 * @param {'neutral'|'green'|'amber'|'red'} [p.tone]
 * @param {React.ReactNode} [p.children]
 * @param {() => void} [p.onClose]
 * @param {React.ReactNode} [p.stamp]
 * @param {React.CSSProperties} [p.style]
 */
export function Toast({ tone = 'neutral', children, onClose, stamp, action, style }) {
  const bg = tone === 'green' ? 'var(--lime)' : tone === 'amber' ? 'var(--gold)' : tone === 'red' ? 'var(--coral)' : 'var(--card)';
  return h('div', { role: 'status', className: 'gx-slap', style: { position: 'relative', display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: bg, color: tone === 'neutral' ? 'var(--tx)' : 'var(--on-accent)', border: ink(2), borderRadius: 10, boxShadow: 'var(--el-2)', fontFamily: BODY, fontSize: 13, fontWeight: 600, transform: 'none', ...style } },
    stamp ? h(Stamp, { tone: 'paper', style: { position: 'absolute', top: -11, left: -6 } }, stamp) : null,
    h('div', { style: { flex: 1 } }, children),
    action ? h('div', { style: { flex: 'none' } }, action) : null,
    onClose ? h('button', { type: 'button', onClick: onClose, 'aria-label': 'Dismiss', style: { border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 800, fontSize: 14, color: 'inherit', fontFamily: BODY } }, '×') : null);
}
